(() => {
  function init(scope) {
    scope.querySelectorAll('[data-driver-share]').forEach(container => {
      if (container.dataset.ready) return;
      container.dataset.ready = 'true';
      const button = container.querySelector('[data-share-button]');
      const status = container.querySelector('[data-share-status]');
      const input = container.querySelector('[data-share-url]');
      const url = document.querySelector('link[rel="canonical"]')?.href || location.href;
      const image = container.querySelector('.rmc-driver-card-preview img');
      if (image) image.addEventListener('error', () => {
        image.hidden = true;
        container.querySelector('[data-card-link]').hidden = true;
        container.querySelector('[data-card-status]').hidden = false;
      });
      button.hidden = false;
      button.addEventListener('click', async () => {
        status.textContent = '';
        try {
          if (navigator.share) {
            await navigator.share({ title: document.title, url });
            return;
          }
          await navigator.clipboard.writeText(url);
          status.textContent = container.dataset.copied;
        } catch (error) {
          if (error.name === 'AbortError') return;
          input.hidden = false;
          input.value = url;
          input.focus();
          input.select();
          status.textContent = container.dataset.manual;
        }
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
